import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';

const trimValidator: ValidatorFn = (text: FormControl) => {
  if (text.value.startsWith(' ')) {
    return {
      trimError: { value: 'text has leading whitespace' },
    };
  }
  if (text.value.endsWith(' ')) {
    return {
      trimError: { value: 'text has trailing whitespace' },
    };
  }
  return null;
};

@Component({
  selector: 'app-govt-manage-schemes',
  templateUrl: './govt-manage-schemes.component.html',
  styleUrls: ['./govt-manage-schemes.component.scss'],
})
export class GovtManageSchemesComponent implements OnInit {
  categoryForm: FormGroup;
  success;
  insertscheme;
  alertMessage: any;
  getGovtSchemes: any[];
  dataSource: any;
  selectedIndex: number;
  paginator: any;
  reg: string | RegExp;
  constructor(
    private datepipe: DatePipe,
    private router: Router,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<GovtManageSchemesComponent>
  ) {}

  ngOnInit(): void {
    this.categoryForm = this.fb.group({
      categoryName: [
        '',
        [
          Validators.required,
          trimValidator,
          Validators.pattern(/^((?!\s{2,}).)*$/),
        ],
      ],
      Remark: [],
    });

    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    let categoryName = '';
    let result = categoryName.trim();
    this.getCategories();
  }
  govtschemedata;
  govtschemedatalist;
  categorydatalist = [];
  categorydata;
  categoryId;
  getcategoryId(id) {
    this.categoryId = id;
  }

  getCategories() {
    this._userService.getCategorylist().subscribe((data) => {
      this.categorydata = data;
      this.categorydatalist = this.categorydata.result.data;
    });
  }

  getActiveCategories() {
    this.spinner.show();
    var postdata = {
      governmentSchemeCategory: this.selectedItems,
    };
    this._userService.getActiveCategory(postdata).subscribe((data) => {
      this.alertMessage = data['result'];
    });
    return this.alertMessage;
  }

  addCategories() {
    if (this.categoryForm.valid) {
      var postData = {
        categoryName: this.categoryForm.value.categoryName,
      };
      this._userService.postGovtSchemeCategory(postData).subscribe((data) => {
        if (data['result'].data == 1) {
          this.toastr.success(data['result'].message, 'Success', {
            timeOut: 3000,
          });
          this.categoryForm.reset();
          this.getCategories();
        } else {
          this.toastr.error(data['result'].message, 'Error', {
            timeOut: 3000,
          });
        }
      });
    }
    this.getCategories();
  }

  onSubmit() {
    if (this._userService.form.valid) {
      this._userService.insertscheme(this._userService.form.value);

      this._userService.form.reset();
      // this._userService.initializeFormGroup();
      this._userService.success('Submitted successfully');
      this.onClear();
    }
  }

  selectedItems: any = [];
  itemToDelete(categoriesItems, event) {
    if (this.selectedItems.find((x) => x == categoriesItems)) {
      this.selectedItems.splice(this.selectedItems.indexOf(categoriesItems), 1);
    } else {
      this.selectedItems.push(categoriesItems);
    }
  }

  onClear() {
    this.dialogRef.close();
    // setTimeout('location.reload(true);', 500);
  }
  /*model pop up same page  */
  deleteCategories() {
    if (this.selectedItems.length > 0) {
      var postdata = {
        governmentSchemeCategory: this.selectedItems,
      };
      this._userService.getActiveCategory(postdata).subscribe((resp) => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeletePopUpManage, {
            width: '35%',
            height: '36%',
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result.result === 'Yes') {
              this.selectedItems.map((ele) => {
                ele.remark = result.remark;
                delete ele.categoryName;
              });
              const deleteBody = {
                governmentSchemeCategory: this.selectedItems,
              };
              this._userService
                .removegovtCategorydata(deleteBody)
                .subscribe((data) => {
                  if (data['result'].data == 1) {
                    this.toastr.success(data['result'].message, 'Success', {
                      timeOut: 3000,
                    });
                    this.selectedItems = [];
                    this.getCategories();
                  }
                });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    } else {
      this.toastr.warning('Please select any one category!', 'Info', {
        timeOut: 3000,
      });
    }
  }

  /*model pop up same page  */
}
/* */
@Component({
  selector: 'delete-pop-up-manage',
  templateUrl: 'delete-pop-up-manage.html',
})
export class DeletePopUpManage {
  formDelete: FormGroup;
  response;
  categoryId;
  marketId;
  constructor(
    public dialogRef: MatDialogRef<DeletePopUpManage>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.formDelete = this.fb.group({
      //  categoryID: ['', [Validators.required]],
      // categoryName: ['', [Validators.required]],
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value: any) {
    if (this.formDelete.valid) {
      var deleteItems = {
        result: value,
        remark: this.formDelete.value.Remark,
      };

      this.dialogRef.close(deleteItems);
    } else {
      alert('Please Enter the valid remark!');
    }
  }
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }
}
